<template>
  <div>
    <div class="section">
      <div class="container">
        <!-- Page Header -->
        <div class="mb-sm">
          <div class="columns is-centered">
            <div class="column is-one-third">
              <h1 class="has-text-centered is-size-4">Orders</h1>
            </div>
          </div>
        </div>
        <!-- Content -->
        <div class="mb-lg">
          <div class="columns is-centered">
            <div class="column is-full-tablet is-four-fifths-widescreen">
              <!-- Order Search -->
              <div class="rounded-lg has-background-white mb-lg pa-md">
                <div class="columns">
                  <div class="column">
                    <order-search />
                  </div>
                  <div class="column is-narrow">
                    <b-dropdown expanded position="is-bottom-left">
                      <button class="button is-medium is-fullwidth" slot="trigger">
                        <b-icon icon="dots-vertical"></b-icon>
                        <span>More</span>
                      </button>
                      <template v-if="context.isSupplier()">
                        <b-dropdown-item has-link>
                          <a href="#" @click.prevent="importFulfillemts('shipments')">Import Tracking Numbers</a>
                        </b-dropdown-item>
                        <b-dropdown-item has-link>
                          <a href="#" @click.prevent="importFulfillemts('invoices')">Import Invoices</a>
                        </b-dropdown-item>
                        <hr class="dropdown-divider">
                      </template>
                      <b-dropdown-item has-link>
                        <router-link :to="{ name: 'shipments.list' }">Review Tracking #s</router-link>
                      </b-dropdown-item>
                      <b-dropdown-item has-link>
                        <router-link :to="{ name: 'invoices.list' }">Review Invoices</router-link>
                      </b-dropdown-item>
                      <!-- Cancels (Context-Sensitive) -->
                      <template v-if="context.isSupplier()">
                        <b-dropdown-item has-link>
                          <router-link :to="{ name: 'cancels.list', query: { preset: 'newRetailer' } }">Review Cancels</router-link>
                        </b-dropdown-item>
                      </template>
                      <template v-else>
                        <b-dropdown-item has-link>
                          <router-link :to="{ name: 'cancels.list', query: { preset: 'newBrand' } }">Review Cancels</router-link>
                        </b-dropdown-item>
                      </template>
                      <!-- Returns -->
                      <b-dropdown-item has-link>
                        <router-link :to="{ name: 'returns.list' }">Review Returns</router-link>
                      </b-dropdown-item>
                      <b-dropdown-item has-link>
                        <router-link :to="{ name: 'credits.list' }">Review Credit Memos</router-link>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
              </div>
              <!-- Order Browser -->
              <div class="columns">
                <div class="column">
                  <!-- Workflow -->
                  <div class="mb-xl">
                    <p class="has-text-weight-bold has-text-centered mb-sm pt-xs">Open Orders</p>
                    <!-- New (Not Acknowledged) -->
                    <router-link v-if="context.isSupplier()" :to="{ name: 'orders.list', query: { preset: 'new'} }">
                      <div class="has-background-white px-md rounded-lg mb-xxs">
                        <div class="columns is-mobile is-vcentered is-marginless">
                          <div class="column"><p class="has-text-weight-bold">Open: New</p></div>
                          <div class="column is-one-fifth">
                            <div class="has-background-white-ter pt-xs rounded-lg has-text-weight-bold has-text-centered">
                              <span><b-icon icon="chevron-right" /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </router-link>
                    <!-- Open (Awaiting Shipments) -->
                    <router-link :to="{ name: 'orders.list', query: { preset: 'notShipped'} }">
                      <div class="has-background-white px-md rounded-lg mb-xxs">
                        <div class="columns is-mobile is-vcentered is-marginless">
                          <div class="column"><p class="has-text-weight-bold">Open: Awaiting Fulfillment</p></div>
                          <div class="column is-one-fifth">
                            <div class="has-background-white-ter pt-xs rounded-lg has-text-weight-bold has-text-centered">
                              <span><b-icon icon="chevron-right" /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </router-link>
                    <!-- Open (Awaiting Invoice) -->
                    <router-link :to="{ name: 'orders.list', query: { preset: 'notInvoiced'} }">
                      <div class="has-background-white px-md rounded-lg mb-xxs">
                        <div class="columns is-mobile is-vcentered is-marginless">
                          <div class="column"><p class="has-text-weight-bold">Open: Awaiting Invoicing</p></div>
                          <div class="column is-one-fifth">
                            <div class="has-background-white-ter pt-xs rounded-lg has-text-weight-bold has-text-centered">
                              <span><b-icon icon="chevron-right" /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </router-link>
                    <!-- Open (All) -->
                    <router-link :to="{ name: 'orders.list', query: { preset: 'open'} }">
                      <div class="has-background-white px-md rounded-lg mb-xxs">
                        <div class="columns is-mobile is-vcentered is-marginless">
                          <div class="column"><p class="has-text-weight-bold">Open: All</p></div>
                          <div class="column is-one-fifth">
                            <div class="has-background-white-ter pt-xs rounded-lg has-text-weight-bold has-text-centered">
                              <span><b-icon icon="chevron-right" /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <!-- Backorders -->
                  <div class="mb-lg">
                    <p class="has-text-weight-bold has-text-centered mb-sm pt-xs">Backorders</p>
                    <!-- New Backorders (i.e. Open & Not Acknowledged) -->
                    <router-link :to="{ name: 'orders.list', query: { preset: 'newBackorders'} }">
                      <div class="has-background-white px-md rounded-lg mb-xxs">
                        <div class="columns is-mobile is-vcentered is-marginless">
                          <div class="column"><p class="has-text-weight-bold">Backordered: New</p></div>
                          <div class="column is-one-fifth">
                            <div class="has-background-white-ter pt-xs rounded-lg has-text-weight-bold has-text-centered">
                              <span><b-icon icon="chevron-right" /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </router-link>
                    <!-- All Open Backorders -->
                    <router-link :to="{ name: 'orders.list', query: { preset: 'backordered'} }">
                      <div class="has-background-white px-md rounded-lg mb-xxs">
                        <div class="columns is-mobile is-vcentered is-marginless">
                          <div class="column"><p class="has-text-weight-bold">Backordered: All</p></div>
                          <div class="column is-one-fifth">
                            <div class="has-background-white-ter pt-xs rounded-lg has-text-weight-bold has-text-centered">
                              <span><b-icon icon="chevron-right" /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <div class="column">
                  <!-- Attention Needed -->
                  <div class="mb-lg">
                    <p class="has-text-weight-bold has-text-centered mb-sm pt-xs">Need Attention</p>
                    <!-- RMAs -->
                    <RmaSummary/>
                    <!-- Orders with unread memos -->
                    <UnreadMemosSummary />
                  </div>
                  <!-- Aging -->
                  <div class="mb-lg">
                    <order-aging />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- New Dashboard-->
          <div class="has-text-centered">
            <router-link :to="{ name: 'orders.dashboard' }" class="has-text-weight-bold has-text-grey-light is-size-8">New Dashboard (beta)</router-link>
          </div>
          <!-- EDI Link -->
          <div v-if="auth.isStaff && context.isSupplier()" class="has-text-centered">
            <router-link :to="{ name: 'edi.envelopes' }" class="has-text-weight-bold has-text-info">Go to EDI Dashboard</router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- Import Shipments/Invoices Modal -->
    <b-modal :active.sync="showImportFulfillmentsModal" has-modal-card :can-cancel="[]">
      <ImportFulfillmentsModal :data-type="importDataType" />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OrderAging from '../components/Dashboard/OrderAging'
import OrderSearch from '../components/Dashboard/OrderSearch'
import RmaSummary from '../components/Dashboard/RmaSummary'
import UnreadMemosSummary from '../components/Dashboard/UnreadMemosSummary'
import ImportFulfillmentsModal from '../components/Dashboard/ImportFulfillmentsModal'

export default {
  components: {
    ImportFulfillmentsModal,
    OrderAging,
    OrderSearch,
    RmaSummary,
    UnreadMemosSummary
  },
  data () {
    return {
      importDataType: null,
      showImportFulfillmentsModal: false
    }
  },
  computed: {
    ...mapGetters(['app', 'auth', 'context'])
  },
  methods: {
    importFulfillemts (dataType) {
      this.importDataType = dataType
      this.showImportFulfillmentsModal = true
    }
  }
}
</script>
